import {Component} from 'react'

import {Router} from '../routes.js'

class Page extends Component {
    constructor(props) {
        super(props)
    }

    backpage() {
        // return Router
    }
}

export default Page


// WEBPACK FOOTER //
// components/Page.js